<template>
  <!-- 二维码 -->
    <!-- <pops :show="isShowQR" id="QRcode"  :title="'二维码'" @closePop="closeQR" >

    </pops> -->
    <div class="QRimg_main">

      <div class="QRimg_body">
        <div class="QRimg_head">
        <span class="QRimg_text">二维码</span>
        <i @click="closeQR" title="关闭" class="QRimg_close">X</i>
      </div>
        <div style="text-align: center;">
          <div class="image_title">{{QRTitle}}</div>
          <img :src="QRcodeImg" alt="">
        </div>
      </div>
    </div>
</template>
<style scoped>
  .image_title{
    font-size: 14px;
    margin-top: 5px;
    height: 20px;
  }
  .QRimg_main{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(192,196,204,0.5);
  }
  .QRimg_head{
    height: 30px;
    width: 400px;
    background: #ffffff;
    border-bottom: 2px solid #999;
  }
  .QRimg_body{
    width: 400px;
    height:370px;
    background: #ffffff;
    margin: auto;
    margin-top: 200px;
    background: #ffffff;
  }
  .QRimg_text{
    font-size: 14px;
    font-weight: bolder;
    color: #000;
    line-height: 30px;
    margin-left: 20px;
  }
  .QRimg_close{
    float: right;
    font-size: 16px;
    margin-right: 10px;
    margin-top: 7px;
    cursor: pointer;
  }
  .QRimg_close:hover{
    font-size: 18px;
  }
</style>

<script>
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
export default {
  components: {
      pops
    },
  props:{
    QRId:{//医院id
      require:true,
      type: String,
    },
    QRType:{
      require:true,
      type: String,
    },
    QRTitle:{
      require:true,
      type:String,
    }
  },
  data() {
    return {
      isShowQR:false,
      QRcodeImg:"",
    }
  },
  created() {
    this.isShowQR=true;
    this.getQRcode();
  },
  methods: {
    getQRcode(){
      this.QRcodeImg=`${window.BASE_URL}/video/getQRCodeForVideoAddr.json?Id=${this.QRId}&type=${this.QRType}`
    },
    closeQR(){
      this.isShowQR=false;
      this.$emit("closeQR");
    }
  },
}
</script>



// WEBPACK FOOTER //
// QRcodePage.vue?0dd1fcfd